// controllers/auto_click_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    once: { type: Boolean, default: true }, // кликнуть один раз или при каждом появлении
  };

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.click();
          if (this.onceValue) {
            this.observer.disconnect();
          }
        }
      });
    });

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  click() {
    if (this.element.tagName === "A") {
      this.element.click();
    } else {
      // если не ссылка, можно сгенерировать событие клика на дочерней ссылке
      const link = this.element.querySelector("a");
      if (link) link.click();
    }
  }
}
